export let CANCEL_BOOKING_BUTTON = 'cancel-booking-button';
export let BOOKING_OPTIONS_MENU = 'booking-options-menu';
export const BOOKING_TABLE = 'booking-table';
export const BOOKING_TABLE_ROW = 'booking-table-row';
